export default __webpack_public_path__ + "static/media/logo_big.94f1e075.svg";